import "core-js/modules/es6.array.reduce";
import _toConsumableArray from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.repeat";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.assign";
import _classCallCheck from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import { isArray } from 'vega-util';
import { COLUMN, FACET, ROW } from '../channel';
import { boxPlotNormalizer } from '../compositemark/boxplot';
import { errorBandNormalizer } from '../compositemark/errorband';
import { errorBarNormalizer } from '../compositemark/errorbar';
import { channelHasField } from '../encoding';
import * as log from '../log';
import { isFacetMapping } from '../spec/facet';
import { SpecMapper } from '../spec/map';
import { isLayerRepeatSpec } from '../spec/repeat';
import { isUnitSpec } from '../spec/unit';
import { keys, omit, varName } from '../util';
import { PathOverlayNormalizer } from './pathoverlay';
import { RangeStepNormalizer } from './rangestep';
import { replaceRepeaterInEncoding, replaceRepeaterInFacet } from './repeater';
import { RuleForRangedLineNormalizer } from './ruleforrangedline';
export var CoreNormalizer =
/*#__PURE__*/
function (_SpecMapper) {
  _inherits(CoreNormalizer, _SpecMapper);

  function CoreNormalizer() {
    var _this;

    _classCallCheck(this, CoreNormalizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CoreNormalizer).apply(this, arguments));
    _this.nonFacetUnitNormalizers = [boxPlotNormalizer, errorBarNormalizer, errorBandNormalizer, new PathOverlayNormalizer(), new RuleForRangedLineNormalizer(), new RangeStepNormalizer()];
    return _this;
  }

  _createClass(CoreNormalizer, [{
    key: "map",
    value: function map(spec, params) {
      // Special handling for a faceted unit spec as it can return a facet spec, not just a layer or unit spec like a normal unit spec.
      if (isUnitSpec(spec)) {
        var hasRow = channelHasField(spec.encoding, ROW);
        var hasColumn = channelHasField(spec.encoding, COLUMN);
        var hasFacet = channelHasField(spec.encoding, FACET);

        if (hasRow || hasColumn || hasFacet) {
          return this.mapFacetedUnit(spec, params);
        }
      }

      return _get(_getPrototypeOf(CoreNormalizer.prototype), "map", this).call(this, spec, params);
    } // This is for normalizing non-facet unit

  }, {
    key: "mapUnit",
    value: function mapUnit(spec, params) {
      var parentEncoding = params.parentEncoding,
          parentProjection = params.parentProjection;
      var specWithReplacedEncoding = Object.assign(Object.assign({}, spec), {
        encoding: replaceRepeaterInEncoding(spec.encoding, params.repeater)
      });

      if (parentEncoding || parentProjection) {
        return this.mapUnitWithParentEncodingOrProjection(specWithReplacedEncoding, params);
      }

      var normalizeLayerOrUnit = this.mapLayerOrUnit.bind(this);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.nonFacetUnitNormalizers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var unitNormalizer = _step.value;

          if (unitNormalizer.hasMatchingType(specWithReplacedEncoding, params.config)) {
            return unitNormalizer.run(specWithReplacedEncoding, params, normalizeLayerOrUnit);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return specWithReplacedEncoding;
    }
  }, {
    key: "mapRepeat",
    value: function mapRepeat(spec, params) {
      if (isLayerRepeatSpec(spec)) {
        return this.mapLayerRepeat(spec, params);
      } else {
        return this.mapNonLayerRepeat(spec, params);
      }
    }
  }, {
    key: "mapLayerRepeat",
    value: function mapLayerRepeat(spec, params) {
      var _this2 = this;

      var repeat = spec.repeat,
          childSpec = spec.spec,
          rest = __rest(spec, ["repeat", "spec"]);

      var row = repeat.row,
          column = repeat.column,
          layer = repeat.layer;
      var _params$repeater = params.repeater,
          repeater = _params$repeater === void 0 ? {} : _params$repeater,
          _params$repeaterPrefi = params.repeaterPrefix,
          repeaterPrefix = _params$repeaterPrefi === void 0 ? '' : _params$repeaterPrefi;

      if (row || column) {
        return this.mapRepeat(Object.assign(Object.assign({}, spec), {
          repeat: Object.assign(Object.assign({}, row ? {
            row: row
          } : {}), column ? {
            column: column
          } : {}),
          spec: {
            repeat: {
              layer: layer
            },
            spec: childSpec
          }
        }), params);
      } else {
        return Object.assign(Object.assign({}, rest), {
          layer: layer.map(function (layerValue) {
            var childRepeater = Object.assign(Object.assign({}, repeater), {
              layer: layerValue
            });
            var childName = (childSpec.name || '') + repeaterPrefix + "child__layer_".concat(varName(layerValue));

            var child = _this2.mapLayerOrUnit(childSpec, Object.assign(Object.assign({}, params), {
              repeater: childRepeater,
              repeaterPrefix: childName
            }));

            child.name = childName;
            return child;
          })
        });
      }
    }
  }, {
    key: "mapNonLayerRepeat",
    value: function mapNonLayerRepeat(spec, params) {
      var _a;

      var _spec = spec,
          repeat = _spec.repeat,
          childSpec = _spec.spec,
          data = _spec.data,
          remainingProperties = __rest(spec, ["repeat", "spec", "data"]);

      if (!isArray(repeat) && spec.columns) {
        // is repeat with row/column
        spec = omit(spec, ['columns']);
        log.warn(log.message.columnsNotSupportByRowCol('repeat'));
      }

      var concat = [];
      var _params$repeater2 = params.repeater,
          repeater = _params$repeater2 === void 0 ? {} : _params$repeater2,
          _params$repeaterPrefi2 = params.repeaterPrefix,
          repeaterPrefix = _params$repeaterPrefi2 === void 0 ? '' : _params$repeaterPrefi2;
      var row = !isArray(repeat) && repeat.row || [repeater ? repeater.row : null];
      var column = !isArray(repeat) && repeat.column || [repeater ? repeater.column : null];
      var repeatValues = isArray(repeat) && repeat || [repeater ? repeater.repeat : null]; // cross product

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = repeatValues[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var repeatValue = _step2.value;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = row[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var rowValue = _step3.value;
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = column[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var columnValue = _step4.value;
                  var childRepeater = {
                    repeat: repeatValue,
                    row: rowValue,
                    column: columnValue,
                    layer: repeater.layer
                  };
                  var childName = (childSpec.name || '') + repeaterPrefix + 'child__' + (isArray(repeat) ? "".concat(varName(repeatValue)) : (repeat.row ? "row_".concat(varName(rowValue)) : '') + (repeat.column ? "column_".concat(varName(columnValue)) : ''));
                  var child = this.map(childSpec, Object.assign(Object.assign({}, params), {
                    repeater: childRepeater,
                    repeaterPrefix: childName
                  }));
                  child.name = childName; // we move data up

                  concat.push(omit(child, ['data']));
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                    _iterator4["return"]();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                _iterator3["return"]();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var columns = isArray(repeat) ? spec.columns : repeat.column ? repeat.column.length : 1;
      return Object.assign(Object.assign({
        data: (_a = childSpec.data) !== null && _a !== void 0 ? _a : data,
        align: 'all'
      }, remainingProperties), {
        columns: columns,
        concat: concat
      });
    }
  }, {
    key: "mapFacet",
    value: function mapFacet(spec, params) {
      var _spec2 = spec,
          facet = _spec2.facet;

      if (isFacetMapping(facet) && spec.columns) {
        // is facet with row/column
        spec = omit(spec, ['columns']);
        log.warn(log.message.columnsNotSupportByRowCol('facet'));
      }

      return _get(_getPrototypeOf(CoreNormalizer.prototype), "mapFacet", this).call(this, spec, params);
    }
  }, {
    key: "mapUnitWithParentEncodingOrProjection",
    value: function mapUnitWithParentEncodingOrProjection(spec, params) {
      var encoding = spec.encoding,
          projection = spec.projection;
      var parentEncoding = params.parentEncoding,
          parentProjection = params.parentProjection,
          config = params.config;
      var mergedProjection = mergeProjection({
        parentProjection: parentProjection,
        projection: projection
      });
      var mergedEncoding = mergeEncoding({
        parentEncoding: parentEncoding,
        encoding: replaceRepeaterInEncoding(encoding, params.repeater)
      });
      return this.mapUnit(Object.assign(Object.assign(Object.assign({}, spec), mergedProjection ? {
        projection: mergedProjection
      } : {}), mergedEncoding ? {
        encoding: mergedEncoding
      } : {}), {
        config: config
      });
    }
  }, {
    key: "mapFacetedUnit",
    value: function mapFacetedUnit(spec, params) {
      // New encoding in the inside spec should not contain row / column
      // as row/column should be moved to facet
      var _a = spec.encoding,
          row = _a.row,
          column = _a.column,
          facet = _a.facet,
          encoding = __rest(_a, ["row", "column", "facet"]); // Mark and encoding should be moved into the inner spec


      var mark = spec.mark,
          width = spec.width,
          projection = spec.projection,
          height = spec.height,
          view = spec.view,
          selection = spec.selection,
          _ = spec.encoding,
          outerSpec = __rest(spec, ["mark", "width", "projection", "height", "view", "selection", "encoding"]);

      var _this$getFacetMapping = this.getFacetMappingAndLayout({
        row: row,
        column: column,
        facet: facet
      }, params),
          facetMapping = _this$getFacetMapping.facetMapping,
          layout = _this$getFacetMapping.layout;

      var newEncoding = replaceRepeaterInEncoding(encoding, params.repeater);
      return this.mapFacet(Object.assign(Object.assign(Object.assign({}, outerSpec), layout), {
        // row / column has higher precedence than facet
        facet: facetMapping,
        spec: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, width ? {
          width: width
        } : {}), height ? {
          height: height
        } : {}), view ? {
          view: view
        } : {}), projection ? {
          projection: projection
        } : {}), {
          mark: mark,
          encoding: newEncoding
        }), selection ? {
          selection: selection
        } : {})
      }), params);
    }
  }, {
    key: "getFacetMappingAndLayout",
    value: function getFacetMappingAndLayout(facets, params) {
      var _a;

      var row = facets.row,
          column = facets.column,
          facet = facets.facet;

      if (row || column) {
        if (facet) {
          log.warn(log.message.facetChannelDropped([].concat(_toConsumableArray(row ? [ROW] : []), _toConsumableArray(column ? [COLUMN] : []))));
        }

        var facetMapping = {};
        var layout = {};

        for (var _i = 0, _arr = [ROW, COLUMN]; _i < _arr.length; _i++) {
          var channel = _arr[_i];
          var def = facets[channel];

          if (def) {
            var align = def.align,
                center = def.center,
                spacing = def.spacing,
                columns = def.columns,
                defWithoutLayout = __rest(def, ["align", "center", "spacing", "columns"]);

            facetMapping[channel] = defWithoutLayout;

            for (var _i2 = 0, _arr2 = ['align', 'center', 'spacing']; _i2 < _arr2.length; _i2++) {
              var prop = _arr2[_i2];

              if (def[prop] !== undefined) {
                layout[prop] = (_a = layout[prop]) !== null && _a !== void 0 ? _a : {};
                layout[prop][channel] = def[prop];
              }
            }
          }
        }

        return {
          facetMapping: facetMapping,
          layout: layout
        };
      } else {
        var _align = facet.align,
            _center = facet.center,
            _spacing = facet.spacing,
            _columns = facet.columns,
            _facetMapping = __rest(facet, ["align", "center", "spacing", "columns"]);

        return {
          facetMapping: replaceRepeaterInFacet(_facetMapping, params.repeater),
          layout: Object.assign(Object.assign(Object.assign(Object.assign({}, _align ? {
            align: _align
          } : {}), _center ? {
            center: _center
          } : {}), _spacing ? {
            spacing: _spacing
          } : {}), _columns ? {
            columns: _columns
          } : {})
        };
      }
    }
  }, {
    key: "mapLayer",
    value: function mapLayer(spec, _a) {
      // Special handling for extended layer spec
      var parentEncoding = _a.parentEncoding,
          parentProjection = _a.parentProjection,
          otherParams = __rest(_a, ["parentEncoding", "parentProjection"]);

      var encoding = spec.encoding,
          projection = spec.projection,
          rest = __rest(spec, ["encoding", "projection"]);

      var params = Object.assign(Object.assign({}, otherParams), {
        parentEncoding: mergeEncoding({
          parentEncoding: parentEncoding,
          encoding: encoding
        }),
        parentProjection: mergeProjection({
          parentProjection: parentProjection,
          projection: projection
        })
      });
      return _get(_getPrototypeOf(CoreNormalizer.prototype), "mapLayer", this).call(this, rest, params);
    }
  }]);

  return CoreNormalizer;
}(SpecMapper);

function mergeEncoding(opt) {
  var parentEncoding = opt.parentEncoding,
      encoding = opt.encoding;

  if (parentEncoding && encoding) {
    var overriden = keys(parentEncoding).reduce(function (o, key) {
      if (encoding[key]) {
        o.push(key);
      }

      return o;
    }, []);

    if (overriden.length > 0) {
      log.warn(log.message.encodingOverridden(overriden));
    }
  }

  var merged = Object.assign(Object.assign({}, parentEncoding !== null && parentEncoding !== void 0 ? parentEncoding : {}), encoding !== null && encoding !== void 0 ? encoding : {});
  return keys(merged).length > 0 ? merged : undefined;
}

function mergeProjection(opt) {
  var parentProjection = opt.parentProjection,
      projection = opt.projection;

  if (parentProjection && projection) {
    log.warn(log.message.projectionOverridden({
      parentProjection: parentProjection,
      projection: projection
    }));
  }

  return projection !== null && projection !== void 0 ? projection : parentProjection;
}